/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response from generating MNCAP quote PDF
 * @export
 * @interface GenerateMNCAPQuoteResponse
 */
export interface GenerateMNCAPQuoteResponse {
    /**
     * ID du fichier stocke
     * @type {string}
     * @memberof GenerateMNCAPQuoteResponse
     */
    storedFileId?: string;
    /**
     * URL temporaire du fichier PDF
     * @type {string}
     * @memberof GenerateMNCAPQuoteResponse
     */
    url?: string;
}

/**
 * Check if a given object implements the GenerateMNCAPQuoteResponse interface.
 */
export function instanceOfGenerateMNCAPQuoteResponse(value: object): value is GenerateMNCAPQuoteResponse {
    return true;
}

export function GenerateMNCAPQuoteResponseFromJSON(json: any): GenerateMNCAPQuoteResponse {
    return GenerateMNCAPQuoteResponseFromJSONTyped(json, false);
}

export function GenerateMNCAPQuoteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateMNCAPQuoteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'storedFileId': json['storedFileId'] == null ? undefined : json['storedFileId'],
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function GenerateMNCAPQuoteResponseToJSON(json: any): GenerateMNCAPQuoteResponse {
    return GenerateMNCAPQuoteResponseToJSONTyped(json, false);
}

export function GenerateMNCAPQuoteResponseToJSONTyped(value?: GenerateMNCAPQuoteResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'storedFileId': value['storedFileId'],
        'url': value['url'],
    };
}

